import { GetterTree } from 'vuex';
import {
	Reporter,
	IReportingEvent,
} from '@andromeda/telemetry-data-access-orion';
import { IReport } from '@/interfaces/IReport';
// eslint-disable-next-line camelcase
// import { sm_params } from '@/main';
import {
	GET_ACTIVE_CARD_INDEX,
	GET_CARDS,
	GET_CARD_CLICK_REPORT,
	GET_CAROUSEL_CLICK_REPORT,
	GET_CHECKOUT_TOTAL,
	GET_CURRENT_CARD,
	GET_CURRENT_MXR_RETAILER,
	GET_DESELECT_CLICKED_REPORT,
	GET_FOOTER_BUTTON_CLICKED_REPORT,
	GET_FOOTER_CTA,
	GET_GAM_SM_PARAMS,
	GET_IS_DEFAULT,
	GET_LOCATION_CLICKED_REPORT,
	GET_MXR_CONFIG,
	GET_MXR_IMPRESSION_REPORT,
	GET_MXR_KROGER_CHECKOUT_REPORT,
	GET_MXR_TYPE,
	GET_MXR_VIEWED_REPORT,
	GET_OFFERS_COUNT_IN_CART,
	GET_PREVIOUS_CARD_INDEX,
	GET_PREVIOUS_PROMOTION,
	GET_PREVIOUS_PROMOTION_FOR_REPORT,
	GET_REPORTERS,
	GET_REPORT_BASE_PARAMS,
	GET_REPORT_QUEUE,
	GET_RETAILER_OFFERS,
	GET_SELECTED_TAB_INDEX,
	GET_SELECT_CLICKED_REPORT,
	GET_SESSION_ID,
	GET_SWAP_CLICKED_REPORT,
	GET_TABS,
	GET_TAB_CLICK_REPORT,
	GET_THIRD_TAB_CLICK_REPORT,
} from '../types';
import { ITrackingState } from './state';
import { IRootState } from '../mxr-store/state';
import { ICard } from '@/interfaces/Card';
import { IPromotion } from '@andromeda/calvera-ui';
import { getRequestId } from '@andromeda/sites-data-access';

export const getters: GetterTree<ITrackingState, IRootState> = {
	[GET_REPORTERS]: (state: ITrackingState): Reporter[] => state.reporters,
	[GET_REPORT_QUEUE]: (state: ITrackingState): IReportingEvent[] =>
		state.reportQueue,

	[GET_CARD_CLICK_REPORT]: (state: ITrackingState, getter): IReport => {
		const index = getter[GET_PREVIOUS_CARD_INDEX];
		const cards: ICard[] = getter[GET_CARDS];
		const card: ICard | undefined =
			index > -1 && index < cards.length - 1 ? cards[index] : undefined;
		let title = '';
		let previousExternalId = '';

		if (card) {
			title = cards[index].title;
			previousExternalId = card.recipeId;
		}

		return {
			creative: {
				id: getter[GET_MXR_CONFIG].id,
			},
			requestId: getRequestId(window),
			sessionId: getter[GET_SESSION_ID],
			...getter[GET_GAM_SM_PARAMS],
			mxrCardClicked: {
				card: {
					index: getter[GET_ACTIVE_CARD_INDEX],
					title: getter[GET_CURRENT_CARD].title,
				},
				carouselOffers: getter[GET_RETAILER_OFFERS],
				defaultShown: getter[GET_IS_DEFAULT],
				externalId: getter[GET_CURRENT_CARD].recipeId,
				previousCard: {
					index,
					title,
				},
				previousExternalId,
				...getter[GET_REPORT_BASE_PARAMS],
			},
		};
	},
	[GET_TAB_CLICK_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrTabClicked: {
			card: {
				index: getter[GET_ACTIVE_CARD_INDEX],
				title: getter[GET_CURRENT_CARD].title,
			},
			carouselOffers: getter[GET_RETAILER_OFFERS],
			defaultShown: getter[GET_IS_DEFAULT],
			externalId: getter[GET_CURRENT_CARD].recipeId,
			tab: {
				index: getter[GET_SELECTED_TAB_INDEX],
				label: getter[GET_TABS][getter[GET_SELECTED_TAB_INDEX] - 1],
			},
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_PREVIOUS_PROMOTION_FOR_REPORT]: (
		state: ITrackingState,
		getter
	): IPromotion => {
		const previousPromotion: IPromotion = getter[GET_PREVIOUS_PROMOTION];
		return {
			...previousPromotion,
			id: `${previousPromotion.id}`,
		};
	},
	[GET_CAROUSEL_CLICK_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrCarouselClicked: {
			carouselOffers: getter[GET_RETAILER_OFFERS],
			defaultShown: getter[GET_IS_DEFAULT],
			previousCarouselOffer: getter[GET_PREVIOUS_PROMOTION_FOR_REPORT],
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_THIRD_TAB_CLICK_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrThirdTabButtonClicked: {
			// button: {},
			card: {
				index: getter[GET_ACTIVE_CARD_INDEX],
				title: getter[GET_CURRENT_CARD].title,
			},
			carouselOffers: getter[GET_RETAILER_OFFERS],
			checkoutTotal: 0,
			ctaButtonUrl: getter[GET_CURRENT_CARD].callToActionUrl,
			defaultShown: getter[GET_IS_DEFAULT],
			externalId: getter[GET_CURRENT_CARD].recipeId,
			offersCountInCart: getter[GET_OFFERS_COUNT_IN_CART],
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_MXR_IMPRESSION_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrImpression: {
			card: {
				index: getter[GET_ACTIVE_CARD_INDEX],
				title: getter[GET_CURRENT_CARD].title,
			},
			carouselOffers: getter[GET_RETAILER_OFFERS],
			defaultShown: getter[GET_IS_DEFAULT],
			externalId: getter[GET_CURRENT_CARD].recipeId,
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_MXR_VIEWED_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrViewed: {
			card: {
				index: getter[GET_ACTIVE_CARD_INDEX],
				title: getter[GET_CURRENT_CARD].title,
			},
			carouselOffers: getter[GET_RETAILER_OFFERS],
			defaultShown: getter[GET_IS_DEFAULT],
			externalId: getter[GET_CURRENT_CARD].recipeId,
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_FOOTER_BUTTON_CLICKED_REPORT]: (
		state: ITrackingState,
		getter
	): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrFooterButtonClicked: {
			button: {
				...getter[GET_FOOTER_CTA],
				defaultUrl: getter[GET_FOOTER_CTA].url,
				type: getter[GET_FOOTER_CTA].ctaType,
			},
			card: {
				index: getter[GET_ACTIVE_CARD_INDEX],
				title: getter[GET_CURRENT_CARD].title,
			},
			carouselOffers: getter[GET_RETAILER_OFFERS],
			checkoutTotal: getter[GET_CHECKOUT_TOTAL],
			ctaButtonUrl: getter[GET_CURRENT_CARD].callToActionUrl,
			defaultShown: getter[GET_IS_DEFAULT],
			externalId: getter[GET_CURRENT_CARD].recipeId,
			offersCountInCart: getter[GET_OFFERS_COUNT_IN_CART],
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_LOCATION_CLICKED_REPORT]: (
		state: ITrackingState,
		getter
	): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrLocationClicked: {
			// previousRetailer: {},
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_DESELECT_CLICKED_REPORT]: (
		state: ITrackingState,
		getter
	): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrDeselectClicked: {
			// carouselOffer: {},
			shoppingListOffer: {},
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_SELECT_CLICKED_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrSelectClicked: {
			// carouselOffer: {},
			// shoppingListOffer: {},
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_SWAP_CLICKED_REPORT]: (state: ITrackingState, getter): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrSwapClicked: {
			// carouselOffer: {},
			// previousCarouselOffer: {},
			// previousShoppingListOffer: {},
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_MXR_KROGER_CHECKOUT_REPORT]: (
		state: ITrackingState,
		getter
	): IReport => ({
		creative: {
			id: getter[GET_MXR_CONFIG].id,
		},
		requestId: getRequestId(window),
		sessionId: getter[GET_SESSION_ID],
		...getter[GET_GAM_SM_PARAMS],
		mxrKrogerCheckout: {
			...getter[GET_REPORT_BASE_PARAMS],
		},
	}),
	[GET_REPORT_BASE_PARAMS]: (state: ITrackingState, getter) => ({
		retailer: {
			id: getter[GET_CURRENT_MXR_RETAILER].FulfillmentStoreId,
			location: getter[GET_CURRENT_MXR_RETAILER].LocationId,
			name: getter[GET_CURRENT_MXR_RETAILER].Chain,
		},
		retailerIntegration: getter[GET_MXR_CONFIG].retailerIntegration,
		size: getter[GET_MXR_CONFIG].size,
		type: getter[GET_MXR_TYPE],
		muid: window.sm_params.ka_muid,
		msg: window.sm_params.ka_msg,
		referer: window.sm_params.referrer,
		originReferer:
			new URLSearchParams(window.location.search).get('origin') ||
			window.parent.document.location.href,
	}),
	[GET_GAM_SM_PARAMS]: (state: ITrackingState, getter) => ({
		gamCreativeId: window.sm_params.creative_id ? window.sm_params.creative_id : '',
		gamLineItemId: window.sm_params.line_item_id ? window.sm_params.line_item_id : '',
	}),
};
